import React, { useRef } from 'react';
import ChatBot from "react-chatbotify";
import { Link } from 'react-router-dom';

import { globalSearch } from '../http/Search_API/Search_API';
import { ClenseNumeral } from '../utils/PageDataPrepare';

const ChatBotComponent = () => {
  const chatbotRef = useRef();

  const helpOptions = [
    'Новости',
    'Доступные категории',
    'Поиск',
    'Подписка',
    'Правила пользования',
    'Позвать человека',
    'Сообщить об ошибке'
  ];

  const flow = {
    "start": {
      message: 'Добро пожаловать в чат-бот приложения Медицинский Атлас! 💊 Здесь вы можете узнать о подписке, доступных категориях и многое другое.',
      options: helpOptions,
      path: "process_options"
    },
    prompt_again: {
      message: 'Что еще вас интересует?',
      options: helpOptions,
      path: "process_options"
    },
    unknown_input: {
      message: 'Если вам нужна помощь, вы можете написать нам на почту support_atlas@pimunn.net',
      options: helpOptions,
      path: "process_options"
    },
    prompt_search_ask: {
      message: '🔎 Для поиска, введите название интересующей Вас категории или нозологии:',
      path: 'process_search',
    },
    process_search: {
      transition: {
        duration: 0
      },
      path: async (params) => {
        const { userInput } = params;

        //  Обработка запроса на поиск чего-то.
        try
        {
          const result = await globalSearch(userInput);
          if (result?.error)
          {
            await params.injectMessage('❌ При поиске возникла ошибка ' + result.error + '\nПопробуйте снова.');
            return 'prompt_again';
          }

          if (!result?.matches?.length)
          {
            await params.injectMessage('Ничего подходящего не нашлось. Попробуйте изменить запрос.');
            return 'prompt_again';
          }

          const { matches } = result;

          //  Что-то нашлось. Отобразить.
          await params.injectMessage(ClenseNumeral(matches.length, [ 'Найдена', 'Найдено', 'Найдено' ]) + ' ' + matches.length + ' ' + ClenseNumeral(matches.length, [ 'подходящая категория.', 'подходящих категории.', 'подходящих категорий.' ]));
          
          for await (const match of matches)
          {
            const { demo, category, name, subcategories, entries } = match;
            const matchesTotalString = ClenseNumeral(subcategories?.length, [ 'схожая подкатегория', 'схожих подкатегории', 'схожих подкатегорий' ]);
            const matchesEntriesTotalString = ClenseNumeral(entries?.length, [ 'подходящий случай', 'подходящих случая', 'подходящих случаев' ]);

            await params.injectMessage(<div className='rcb-bot-message rcb-bot-message-entry' style={{ backgroundColor: 'rgb(229, 231, 235)', color: 'rgb(51, 65, 85)', textAlign: 'left', borderRadius: '12px 12px 12px 0' }}>
              <div>В категории <strong>{name.ru}</strong> найдено <strong>{subcategories.length} {matchesTotalString}</strong>:</div>
              {demo ? <>
                <p>Для просмотра результатов, пожалуйста, приобретите полный доступ</p>
              </> : <ul>
                {subcategories.map( sc => <li key={sc.id}><Link to={sc.path}>{sc.name['ru']}</Link></li> )}
              </ul>}
              {entries?.length && <>
                <div>А также <strong>{entries.length}</strong> {matchesEntriesTotalString}:</div>
                {demo ? <>
                  <p>Для просмотра результатов, пожалуйста, приобретите полный доступ</p>
                </> : <ul>
                  {entries.map( e => <li key={e.id}><Link to={e.path}>{e.name['ru']}</Link></li>)}
                </ul>}
              </>}
            </div>);
          }
        }catch (error)
        {
          await params.injectMessage('❌ При получении ответа на запрос возникла ошибка: ' + error.message + '\nПопробуйте снова.');
        }

        return 'prompt_again';
      }
    },
    process_options: {
      transition: {duration: 0},
      path: async (params) => {
        let link = "";
        switch (params.userInput) {
          case 'Поиск':
            return 'prompt_search_ask';
          case 'Доступные категории': /* • Ортопедия\n• 3D Модели\n• Педиатрия\n• Детская хирургия\n• Малые аномалии развития\n• Анатомия */
            await params.injectMessage('В атласе доступны следующие категории:\n• ЭКГ\n• Эндоскопия\n• Паразитология (Протозоология, Гельминтология, Арахноэнтомология)\n• Гистология\n• Клиническая лабораторная диагностика\n• Лучевая диагностика\n• Микробиология\n• Генетика\n• Ботаника\n• Стоматология\n• Заболевания кожи\n• Ультразвуковая диагностика\n• Карты эпидемий\n• Офтальмология\n• Биология СПО\n• Оториноларингология\n• Клиническая фармакология\n• Аускультация');
            return "prompt_again";
          case 'Подписка':
            await params.injectMessage('Для университетов и колледжей предусмотрены разные ценовые политики.\nВы можете выбрать подходящую подписку в зависимости от количества обучающихся.\n\nУниверситет\nБазовый: 900 000 ₽/год, 1 год, до 500 пользователей\nОптимум: 1 900 000 ₽/год, 1 год, более 500 пользователей\nПремиум: 5 000 000 ₽, 10 лет, нет лимита пользователей\n\nКолледж\nБазовый: 630 000 ₽/год, 1 год, до 500 пользователей\nОптимум: 1 330 000 ₽/год, 1 год, более 500 пользователей\nПремиум: 3 250 000 ₽, 10 лет, нет лимита пользователей\n\nДля быстрой покупки напишите на sale@pimunn.net');
            return "prompt_again";
          case 'Правила пользования':
            link = 'http://med-atlas.site/terms';
            window.open(link, '_blank');
            await params.injectMessage('Перенаправляю вас в этот раздел, оставайтесь на странице');
            return "repeat";
          case 'Новости':
            link = 'http://med-atlas.site/news/';
            window.open(link, '_blank');
            await params.injectMessage('Перенаправляю вас в этот раздел, оставайтесь на странице');
            return "repeat";
          case 'Позвать человека':
            await params.injectMessage('Если вам нужна помощь специалиста, вы можете написать нам на почту support_atlas@pimunn.net');
            return "prompt_again";
          case 'Сообщить об ошибке':
            window.open('mailto:support_atlas@pimunn.net?subject=Ошибка');
            await params.injectMessage('Пожалуйста, обратитесь на support_atlas@pimunn.net с темой письма "Ошибка".');
            return "prompt_again";
          default:
            return "unknown_input";
        }
      },
    },
    repeat: {
      transition: {duration: 3000},
      path: "prompt_again"
    }
  };

  const themes = [
    {id: "simple_blue", version: "0.1.0"}
  ];

  const settings = {
    general: {
      secondaryColor: "#FFFFFF",
      primaryColor: "#FFFF",
      fontFamily: "Helvetica Neue, " +
			"sans-serif",
    },
    isOpen: true,
    audio: {
      disabled: true,
    },
    chatHistory: {
      disabled: true,
    },
    tooltip: {
      mode: "CLOSE",
      text: "Чат-бот",
    },
    chatButton: {
      icon: "https://mininuniver.ru/images/partners/pimu-logo-sign-only.png",
    },
    header: {
      title: (
        <div style={{cursor: "pointer", margin: 0, fontSize: 15}} onClick={
          () => window.open("https://med-atlas.site")
        }>
          Чат-бот
        </div>
      ),
      showAvatar: true,
      avatar: "https://mininuniver.ru/images/partners/pimu-logo-sign-only.png",
    },
    chatInput: {
      disabled: false,
      allowNewline: false,
      enabledPlaceholderText: "Напишите ваш вопрос...",
      disabledPlaceholderText: "",
      showCharacterCount: false,
      characterLimit: -1,
      botDelay: 1000,
      sendButtonIcon: "https://static.thenounproject.com/png/5644145-200.png",
      blockSpam: true,
      showSendButton: true,
    },
    device: {
      desktopEnabled: true,
      mobileEnabled: true,
      applyMobileOptimizations: true,
    }
    // other sections
  };

  return (
    <>
      {/* Стилизация кнопки "Сообщить об ошибке" (7-я в списке) */}
      <style>{`
        .rcb-options-container .rcb-options:nth-child(7) {
          background-color:rgb(164, 0, 0) !important;
          color: #FFFFFF !important;
        }
      `}</style>
      <ChatBot
        ref={chatbotRef}
        settings={settings}
        themes={themes}
        flow={flow}
      />
    </>
  );
};

export default ChatBotComponent;